import moment from 'moment';
import { ConfigConstants } from '../../config/config-constants';
import { ModelOptions } from './model-options';

/**
 * Configure the behaviour of a DateModel
 */
export class DateModelOptions extends ModelOptions {
    public readonly format: string;
    public readonly maxValue: moment.Moment;
    public readonly minValue: moment.Moment;
    public readonly readonly: boolean;
    public readonly displayOnlyMonthYear: boolean;
    public readonly required: boolean;

    public static readonly defaultMaxValue: moment.Moment = moment(0)
        .add(ConfigConstants.maxAmountOfYears, 'years')
        .endOf('day');
    public static readonly defaultMinValue: moment.Moment = moment(0).startOf('day');

    /**
     * Constructor that expects an object with some or all of the supported options set
     *
     * @param root0
     * @param root0.format
     * @param root0.maxValue
     * @param root0.minValue
     * @param root0.readonly
     * @param root0.displayOnlyMonthYear
     * @param root0.required
     */
    public constructor({
        format = ConfigConstants.formatDateNoTimezone,
        maxValue = DateModelOptions.defaultMaxValue,
        minValue = DateModelOptions.defaultMinValue,
        readonly = false,
        displayOnlyMonthYear = false,
        required = true,
    }: {
        format?: string;
        maxValue?: moment.Moment;
        minValue?: moment.Moment;
        readonly?: boolean;
        displayOnlyMonthYear?: boolean;
        required?: boolean;
    } = {}) {
        super();
        this.format = format;
        this.maxValue = maxValue.clone().endOf('day');
        this.minValue = minValue.clone().startOf('day');
        this.readonly = readonly;
        this.displayOnlyMonthYear = displayOnlyMonthYear;
        this.required = required;
    }
}

/**
 * Configure the behaviour of a DateModel
 */
export class DateModelOptionsFromJson extends DateModelOptions {
    public constructor(data: JsonDateModelOptions) {
        super({
            format: data.format,
            minValue: moment(data.minValue),
            maxValue: moment(data.maxValue),
            readonly: data.readonly,
            displayOnlyMonthYear: data.displayOnlyMonthYear,
        });
    }
}

export interface JsonDateModelOptions {
    format: string;
    maxValue: string;
    minValue: string;
    readonly: boolean;
    displayOnlyMonthYear: boolean;
}

// Ensure immutability of default min and max values
Object.freeze(DateModelOptions.defaultMinValue);
Object.freeze(DateModelOptions.defaultMaxValue);
